import { render, staticRenderFns } from "./dormitory.vue?vue&type=template&id=096a774c&"
import script from "./dormitory.vue?vue&type=script&lang=js&"
export * from "./dormitory.vue?vue&type=script&lang=js&"
import style0 from "./dormitory.vue?vue&type=style&index=0&id=096a774c&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports